import { StateCreator } from 'zustand';
import { cleanStore, cleanStoreProp } from '@prodelio/config/state/cleanStore';

export const createCommonSlice: StateCreator<any, any> = (set, get) => ({
  cleanStore: (prop: cleanStoreProp) => cleanStore(set, get, prop),
});
